// src/config/licenseColors.js
const licenseColors = {
  LIB: { etiqueta: 'Libre', color: '#68ae50' },
  LIC: { etiqueta: 'Licencia', color: '#A3E4DB' },
  EST: { etiqueta: 'Licencia por estudio', color: '#A3E4DB' },
  ENF: { etiqueta: 'Enfermedad', color: '#FFE8A1' },
  EXA: { etiqueta: 'Examen Médico', color: '#FFE8A1' },
  X: { etiqueta: 'Eventual', color: '#e88d5a' },
  M: { etiqueta: 'Mantenimiento', color: '#bd3939' },
  // Nuevos estados
  FER: { etiqueta: 'Feriado', color: '#FFCDD2' }, // Rojo claro para feriados
  FREE: { etiqueta: 'Libre', color: '#C8E6C9' }, // Verde claro para días libres
};

export default licenseColors;
